import { Node, Plugin } from 'tiptap'
import { nodeInputRule } from 'tiptap-commands'
// TODO: https://discuss.prosemirror.net/t/getting-a-feel-for-nodeview/972
import Vue from 'vue'
import EditorImageVueComponent from '~/components/editor-Image'

/**
 * Matches following attributes in Markdown-typed image: [, alt, src, title]
 *
 * Example:
 * ![Lorem](image.jpg) -> [, "Lorem", "image.jpg"]
 * ![](image.jpg "Ipsum") -> [, "", "image.jpg", "Ipsum"]
 * ![Lorem](image.jpg "Ipsum") -> [, "Lorem", "image.jpg", "Ipsum"]
 */
const IMAGE_INPUT_REGEX = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export default class Image extends Node {
   get name() {
      return 'image'
   }

   // TODO: This `isReadOnly` option isn't being used. Delete it.
   get defaultOptions() {
      return {
         // access elsewhere with `this.options.isReadOnly`
         isReadOnly: false,
      }
   }

   get schema() {
      return {
         attrs: {
            src: {
               default: null,
            },
            alt: {
               default: null,
            },
            title: {
               default: null,
            },
            caption: {
               default: null,
            },
         },
         inline: false,
         group: 'block',
         isLeaf: true,
         selectable: false,
         draggable: true,
         // parseDOM: [
         //    {
         //       tag: 'img[src]',
         //       getAttrs: dom => ({
         //          src: createImagePath({ src: dom.getAttribute('src'), maxWidth: '722px' }),
         //          srcset: createImageSrcSet({ src: dom.getAttribute('src'), maxWidth: '722' }),
         //          title: dom.getAttribute('title'),
         //          // alt: dom.getAttribute('alt'),
         //       }),
         //    },
         // ],
         toDOM: node => {
            var ComponentClass = Vue.extend(EditorImageVueComponent)
            var instance = new ComponentClass({
               propsData: { node, view: this.view },
            })
            // instance.$slots.default = ['Click me!']
            instance.$mount() // pass nothing
            return instance.$el
         },
      }
   }

   commands({ type, schema }) {
      return attrs => (state, dispatch) => {
         const node = type.create(attrs)

         // This puts the new node on a new line
         // const { selection } = state
         // const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
         // const transaction = state.tr.insert(position, node)

         // This puts the node on the current line
         const transaction = state.tr.replaceSelectionWith(node, false)

         dispatch(transaction)
      }
   }

   inputRules({ type }) {
      return [
         nodeInputRule(IMAGE_INPUT_REGEX, type, match => {
            const [alt, src, title] = match
            return {
               src,
               alt,
               title,
            }
         }),
      ]
   }

   get view() {
      return EditorImageVueComponent
   }

   // get plugins() {
   //    return [
   //       new Plugin({
   //          props: {
   //             handleDOMEvents: {
   //                // drag(view, event) {
   //                //    console.log('DRAGGED....................... !!!')
   //                //    console.log('view: ', view)
   //                //    console.log('event: ', event)
   //                //    console.log(this)
   //                //    var instanceIndex = view.dom.parentNode.getAttribute('id')
   //                //    console.log('instanceIndex: ', instanceIndex)
   //                // },
   //                // drop(view, event) {
   //                // console.log('dropped....................... !!!')
   //                // const hasFiles = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length
   //                // if (!hasFiles) {
   //                //    return
   //                // }
   //                // const images = Array.from(event.dataTransfer.files).filter(file => /image/i.test(file.type))
   //                // if (images.length === 0) {
   //                //    return
   //                // }
   //                // event.preventDefault()
   //                // const { schema } = view.state
   //                // const coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY })
   //                // images.forEach(image => {
   //                //    const reader = new FileReader()
   //                //    reader.onload = readerEvent => {
   //                //       const node = schema.nodes.image.create({
   //                //          src: readerEvent.target.result,
   //                //       })
   //                //       const transaction = view.state.tr.insert(coordinates.pos, node)
   //                //       view.dispatch(transaction)
   //                //    }
   //                //    reader.readAsDataURL(image)
   //                // })
   //                // },
   //             },
   //          },
   //       }),
   //    ]
   // }
}
